export function timeoutPromise(time: number, type: 'resolve'|'reject' = 'resolve'): Promise<void> {
  return new Promise((res, rej) => setTimeout(type === 'resolve' ? res : rej, time));
}